import React, { createContext, useEffect, useState } from "react";

// 1. Context create
const ThemeContext = createContext();

// 2. Provider function
export const ThemeProvider = ({ children }) => {

  // 3. State (localStorage se load)
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "light";
  });

  // 4. Apply theme + save
  useEffect(() => {

    const html = document.documentElement;

    // save in localStorage
    localStorage.setItem("theme", theme);

    // apply class
    if (theme === "dark") {
      html.classList.add("dark");
      html.classList.remove("light");
    } else {
      html.classList.remove("dark");
    }

  }, [theme]);

  // 5. Toggle function
  const toggleTheme = () => {
    setTheme(prev =>
      prev === "dark" ? "light" : "dark"
    );
  };

  return (
    <ThemeContext.Provider
      value={{
        theme,
        toggleTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

// 6. Custom hook (optional but best practice)
export const useTheme = () => React.useContext(ThemeContext);